import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import database from "./config/firebaseConfig";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "./App.css";

import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';

import Dashboard from "./components/Dashboard.jsx";
import Landing from "./pages/LandingPage";
import Collections from "./pages/Collections";
import Destination from './pages/Destination';
import Category from './pages/Category.jsx'
import ContactUs from "./pages/ContactUs";
import Cart from "./pages/Cart";
import Product from "./pages/Product";
import Combos from './pages/Combos.jsx'
import Login from "./pages/LoginPage";
import Profile from "./pages/Profile";
import Orders from "./pages/Orders"
import PageNotFound from "./pages/PageNotFound";
import CheckoutPage from './pages/Checkout';
import ThankYouPage from "./pages/ThankyouPage";
import FloatingCart from "./components/FloatingCart";


const App = () => {
  const [cart, setCart] = useState([]);
  const [loggedInUser, setLoggedInUser] = useState('');
  const [productsData, setProductsData] = useState(null);
  const [productsMap, setProductsMap] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        firebase.auth().onAuthStateChanged((user) => {
          if (user) {
            setLoggedInUser(user.uid); // Update logged-in state
          }
        });
      }
      catch (error) {
        console.log(error.message)
      }
    }
    checkAuth();

    const fetchData = async () => {
      try {
        const snapshot = await database.ref("Products").once("value"); // Correct reference to fetch data
        if (snapshot.val() !== null) {
          const data = snapshot.val();
          setProductsData(data); // Extract category names (keys)
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchData();
  }, [setLoggedInUser, setProductsData]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const snapshot = await database.ref("Products").once("value");
        if (snapshot.exists()) {
          const allProducts = snapshot.val();
          const productLookup = {};
          Object.keys(allProducts).forEach((key) => {
            productLookup[allProducts[key].Name] = allProducts[key];
          });
          setProductsMap(productLookup);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("konkanRouteCart"));
    if (savedCart) {
      setCart(savedCart);
    }
  }, [setCart]);

  const saveCartToLocalStorage = (updatedCart) => {
    setCart(updatedCart);
    localStorage.setItem("konkanRouteCart", JSON.stringify(updatedCart));
  };

  // Add item to cart
  const addToCart = (product, quantity, shouldOpenCart = true) => {
    const existingProductIndex = cart.findIndex(
      (item) => item.Name === product.Name
    );
    let updatedCart;

    if (existingProductIndex !== -1) {
      updatedCart = [...cart];
      updatedCart[existingProductIndex].quantity += quantity;
    } else {
      updatedCart = [...cart, { ...product, quantity }];
    }

    saveCartToLocalStorage(updatedCart);

    if (shouldOpenCart) {
      setIsOpen(true);
    }
  };

  // Update or remove item from cart
  const updateCartQuantity = (productName, quantity) => {
    const updatedCart = cart
      .map((item) =>
        item.Name === productName
          ? { ...item, quantity: Math.max(0, item.quantity + quantity) }
          : item
      )
      .filter((item) => item.quantity > 0); // Remove items with quantity 0

    saveCartToLocalStorage(updatedCart);
  };

  return (
    <>
      <Router>
        <FloatingCart  cart={cart} isOpen={isOpen} setIsOpen={setIsOpen} updateCartQuantity={updateCartQuantity} addToCart={addToCart}/>
        <div>
          <Routes>
            <Route element={<Dashboard cartCount={cart.reduce((total, item) => total + item.quantity, 0)} productsData={productsData} setCart={setCart} />}>
              <Route path="/" element={<Landing productsData={productsData} products={productsMap}/>} />
              <Route path="ContactUs" element={<ContactUs />} />
              <Route path="Collections/" >
                <Route index element={<Collections addToCart={addToCart} productsData={productsData} products={productsMap}/>} />
                <Route path="All" element={<Collections addToCart={addToCart} productsData={productsData} products={productsMap}/>} />
                <Route path="Category/:categoryName" element={<Category addToCart={addToCart} productsData={productsData} products={productsMap}/>} />
                <Route path="Destination" element={<Destination addToCart={addToCart} productsData={productsData} />} />
                <Route path="Combos" element={<Combos addToCart={addToCart} productsData={productsData} />} />
              </Route>
              <Route path="Product/" >
                <Route index element={<Collections productsData={productsData} products={productsMap}/>} />
                <Route path=":productName" element={<Product addToCart={addToCart} productsData={productsData} loggedInUser={loggedInUser} products={productsMap}/>} />
              </Route>
              <Route path="Profile" element={<Profile />} />
              <Route path="Orders" element={<Orders loggedInUser={loggedInUser} />} />
              <Route path="Checkout" element={
                loggedInUser ? (
                  <div>
                    <CheckoutPage cart={cart} loggedInUser={loggedInUser} products={productsMap} />
                  </div>
                ) : (
                  <Navigate to="/Login" />
                )} />
              <Route path="Login" element={<Login setLoggedInUser={setLoggedInUser} />} />
              <Route path="Cart" element={<Cart cart={cart}
                updateCartQuantity={updateCartQuantity}
                loggedInUser={loggedInUser} />} />
              <Route
                path="/ThankYou/:invoiceNo"
                element={<ThankYouPage loggedInUser={loggedInUser} setCart={setCart} />}
              />
            </Route>
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </Router>
    </>
  );
};

export default App;
